export default __webpack_public_path__ + "static/media/mug.fada2280.png";